import React from 'react'

function MainHeadToAppend()
{
  return (
    <div className="TopMenuPanel" id="TopCornerButtonContainer">
        <div className="TopBackgroundThatWillChange"></div>
          <div className="TopMenuSectionWrapper" style={{display: "flex"}} id="TopMenuMainWrapper">

            <div className='MainSearchTopWrapper'>
                <a href="/">
                    <img src="/Assets/images/Icon/pingingo-icon.svg" className="PinginGoLogo"/>
                </a>
                
                <div className="MainTopSectionButtonWrapper BasicChildMargin" id="UserTopInfoWrapper">
                <div className="UserTopInfoWrapper HideOnMobile" id="LanguageChangeTopMenu">
                    <div className="UserTopProfileIcon BasicThinGreyBorder Selectable2">
                    <img src="/Assets/images/CountryCode/Indonesia.svg" className="ImageFullCover"/>
                    </div>
                </div>

                    <a className="BasicTextButton BasicBoxShadow ListinYourAccButton SignInButtonTop Selectable ListingMitraButtons HideOnMobile">
                        <div style={{width: "fit-content", height: "fit-content", display: "flex", margin: "auto"}}>
                        <img className="BasicIconInsideButton" style={{marginLeft: 0}}/>
                            <p id="ListYourAccBtnTxt" className="HideOnMobile" style={{marginTop: "auto", marginBottom: "auto"}}>Listing your Accommodation</p>
                            <p id="ListYourAccBtnTxtShort" className="ShowOnMobile" style={{marginTop: "auto", marginBottom: "auto"}}>Join Now</p>
                        </div>
                    </a>

                    <button className="BasicTextButton BasicBoxShadow OrangeButton2 SignInButtonTop Selectable HideOnMobile" id="LoginInButtonTop" onClick={()=> window.InstantiateLoginPanel('')}>Masuk</button>
                    <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable HideOnMobile" id="SignInButtonTop" onClick={()=> window.InstantiateLoginPanel('')}>Register</button>
                    
                    <div className="UserTopInfoWrapper HideOnMobile" id="UserInfoTopWrapper" style={{display:"none"}}>
                        <div className="UserTopProfileIcon" id="UserTopProfileIcon">
                            <img className="ImageFullCover" style={{opacity: 1}} src="/Assets/images/ProfilePicture.jpg"/>
                        </div>
                        <p className="UserTopProfileName InterBoldTextFont" id="UserTopProfileName">Username</p>
                        <img className="BasicInputFieldChevronIconSearch ToggleArrow Selectable2" id="ToggleArrowTopUser" style={{rotate: "0deg"}}/>
                    </div>

                    <input type="checkbox" className='RightPanelToggleCheck' id="RightPanelToggleCheck" style={{display:"none"}}/>
                    <label htmlFor='RightPanelToggleCheck' className='CircleOrangeButtonWithIcon Selectable ShowOnMobile'>
                        <img src="/Assets/images/ButtonIcon/white-hamburger.svg"/>
                    </label>
                </div>
            </div>

            <div className='ColumnGapLong HotelDetaislHotelName'>
                <img src="/Assets/images/ButtonIcon/chevron.svg" className="BackArrowBigHeader Selectable2 BackButtonMobile" style={{rotate:"90deg"}}></img>
                <p className="RoomHotelNameInsidePanel InterBoldTextFont" id='HotelNameHeaderTopBar' style={{marginTop:"auto", marginBottom:"auto"}}>--</p>

                <label htmlFor='RightPanelToggleCheck' className='CircleOrangeButtonWithIcon Selectable ShowOnMobile' style={{marginLeft:"auto"}}>
                    <img src="/Assets/images/ButtonIcon/white-hamburger.svg"/>
                </label>
            </div>

        </div>
    </div>
  )
}

export default MainHeadToAppend